module.exports = "http://cdn.realive.com.ua/src/views/player/oressale/assets/images/wood_oak.png";